
import React from 'react';
import { Button } from '@/components/ui/button';
import { Share2 } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';

interface ProfileShareButtonProps {
  deepLink: string;
  entityName: string;
}

const ProfileShareButton: React.FC<ProfileShareButtonProps> = ({ deepLink, entityName }) => {
  const { toast } = useToast();
  
  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: `${entityName} Profile`,
        text: `Check out this profile on Ask Dentist`,
        url: deepLink
      }).catch(error => {
        // Fallback to clipboard if sharing fails
        copyToClipboard(deepLink);
      });
    } else {
      // Fallback for browsers that don't support the Web Share API
      copyToClipboard(deepLink);
    }
  };

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(
      () => {
        toast({
          title: "Link copied!",
          description: "Share it with your friends.",
        });
      },
      () => {
        toast({
          title: "Failed to copy",
          description: "Please try again.",
          variant: "destructive",
        });
      }
    );
  };

  return (
    <Button
      onClick={handleShare}
      variant="outline"
      className="flex items-center gap-2 rounded-full shadow-sm hover:shadow-md transition-all"
    >
      <Share2 className="h-4 w-4" />
      <span>Share</span>
    </Button>
  );
};

export default ProfileShareButton;
